import router from "./routes";

export default async () => {
    const response = await fetch(router['about']);
    return await response.text();
}